import instagramIcon from '../assets/images/icons/instaIcon.svg'
import youTubeIcon from '../assets/images/icons/YouTube2.svg'
import paidCampaignIcon from '../assets/images/icons/paidCampaign.png'
import giftingCampaignIcon from '../assets/images/icons/giftingCampaign.png'
import salesCampaignIcon from '../assets/images/icons/salesCampaign.png'
import rocketIcon from '../assets/images/icons/1.png'
import bulbIcon from '../assets/images/icons/2.png'
import boxIcon from '../assets/images/icons/3.png'
import starIcon from '../assets/images/icons/4.png'
import testimonialIcon from '../assets/images/icons/5.png'
import longTermIcon from '../assets/images/icons/6.png'
import contestIcon from '../assets/images/icons/7.png'
import performanceCampaignIcon from '../assets/images/icons/performanceCampaignIcon.png'
import affiliateCampaignIcon from '../assets/images/icons/AffiliateCampaignIcon.png'
import { styled } from '@mui/material/styles';
import SearchInput from '../components/inputs/searchInput'
import { InputAdornment, Paper } from '@mui/material'
import searchIcon from "../assets/images/icons/searchIcon.svg"
import totalCampaignIcon from '../assets/images/icons/totalCampaignIcon.svg'
import liveCampaignIcon from '../assets/images/icons/liveCampaignIcon.svg'
import draftCampaignIcon from '../assets/images/icons/draftCampaignIcon.svg'
import completeCampaignIcon from '../assets/images/icons/completeCampaignIcon.svg'
import uncompleteCampaignIcon from '../assets/images/icons/uncompleteCampaignIcon.svg'
const apiBaseUrl = () => {
  const { hostname } = window.location;
  if (hostname.includes("stage.inflyx.co")) { // for stage server
    return { url: "https://ims-dev-backend.inflyx.co/v1/", environment: 'stage' };
  }
  if (hostname.includes("app.inflyx.co")) { // for Production server
    return { url: "https://ims-api-backend.inflyx.co/v1/", environment: 'production' };
  }
  if (hostname.includes("develop.inflyx.co")) { // for dev server
    return { url: "https://ims-dev-backend.inflyx.co/v1/", environment: 'develop' };
  }
  // return { url: "https://ims-dev-backend.inflyx.co/v1/", environment: 'develop' };
  // return { url: "https://ims-api-backend.inflyx.co/v1/", environment: 'develop' }
  // return { url: "http://localhost:6001/v1/", environment: 'production' }; // for local server
  // return { url: "http://localhost:6001/v1/", environment: 'develop' }; // for local server
  return { url: "https://caryl-unhurried-gricelda.ngrok-free.dev/v1/", environment: 'develop' }; // for local server
}

export const BASE_URL = apiBaseUrl().url;

// ngrok's free tier answers browser-looking requests with an HTML interstitial
// (ERR_NGROK_6024) instead of proxying them. That page carries no CORS headers,
// so every XHR/fetch fails as a "CORS error" in the Network tab and never
// reaches the API at all — while the OPTIONS preflight sails through with 204,
// which makes it look like an auth problem rather than a tunnel problem.
// Sending `ngrok-skip-browser-warning` on each request skips the interstitial.
export const IS_TUNNELLED_API = /\.ngrok(-free)?\.(dev|app|io)\b/.test(BASE_URL);
export const ENVIRONMENT_NAME = apiBaseUrl().environment;
export const FIREBASE_BASE_URL = "http://localhost:3002/v1";
export const phonePreventText = ["e", "E", "+", "-"];

export const citiesInIndia = [
  " Pan India", "Mumbai", "Delhi", "Bangalore", "Hyderabad", "Ahmedabad", "Chennai", "Kolkata", "Surat", "Pune", "Jaipur",
  "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal", "Visakhapatnam", "Pimpri-Chinchwad", "Patna",
  "Vadodara", "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Faridabad", "Meerut", "Rajkot", "Kalyan-Dombivali",
  "Vasai-Virar", "Varanasi", "Srinagar", "Aurangabad", "Dhanbad", "Amritsar", "Navi Mumbai", "Prayagraj",
  "Howrah", "Ranchi", "Jabalpur", "Gwalior", "Coimbatore", "Vijayawada", "Jodhpur", "Madurai", "Raipur", "Kota",
  "Guwahati", "Chandigarh", "Solapur", "Hubballi-Dharwad", "Tiruchirappalli", "Tiruppur", "Moradabad", "Mysore",
  "Bareilly", "Gurgaon", "Aligarh", "Jalandhar", "Bhubaneswar", "Salem", "Mira-Bhayandar", "Warangal",
  "Thiruvananthapuram", "Guntur", "Bhiwandi", "Saharanpur", "Gorakhpur", "Bikaner", "Amravati", "Noida",
  "Jamshedpur", "Bhilai", "Cuttack", "Firozabad", "Kochi", "Nellore", "Bhavnagar", "Dehradun", "Durgapur",
  "Asansol", "Rourkela", "Nanded", "Kolhapur", "Ajmer", "Akola", "Gulbarga", "Jamnagar", "Ujjain", "Loni",
  "Siliguri", "Jhansi", "Ulhasnagar", "Jammu", "Sangli-Miraj & Kupwad", "Mangalore", "Erode", "Belgaum",
  "Ambattur", "Tirunelveli", "Malegaon", "Gaya", "Jalgaon", "Udaipur", "Maheshtala", "Davanagere", "Kozhikode",
  "Kurnool", "Rajpur Sonarpur", "Rajahmundry", "Bokaro", "South Dumdum", "Bellary", "Patiala", "Gopalpur",
  "Agartala", "Bhagalpur", "Muzaffarnagar", "Bhatpara", "Panihati", "Latur", "Dhule", "Tirupati", "Rohtak",
  "Korba", "Bhilwara", "Berhampur", "Muzaffarpur", "Ahmednagar", "Mathura", "Kollam", "Avadi", "Kadapa",
  "Kamarhati", "Sambalpur", "Bilaspur", "Shahjahanpur", "Satara", "Bijapur", "Rampur", "Shivamogga",
  "Chandrapur", "Junagadh", "Thrissur", "Alwar", "Bardhaman", "Kulti", "Kakinada", "Nizamabad", "Parbhani",
  "Tumkur", "Khammam", "Ozhukarai", "Bihar Sharif", "Panipat", "Darbhanga", "Bally", "Aizawl", "Dewas",
  "Ichalkaranji", "Karnal", "Bathinda", "Jalna", "Eluru", "Kirari Suleman Nagar", "Barasat", "Purnia", "Satna",
  "Mau", "Sonipat", "Farrukhabad", "Sagar", "Imphal", "Ratlam", "Hapur", "Arrah", "Karimnagar", "Anantapur",
  "Etawah", "Ambernath", "North Dumdum", "Bharatpur", "Begusarai", "New Delhi", "Gandhidham", "Baranagar",
  "Tiruvottiyur", "Puducherry", "Sikar", "Thoothukudi", "Rewa", "Mirzapur", "Raichur", "Pali", "Ramagundam",
  "Haridwar", "Vijayanagaram", "Katihar", "Nagarcoil", "Sri Ganganagar", "Karawal Nagar", "Mango", "Thanjavur",
  "Bulandshahr", "Uluberia", "Murwara", "Sambhal", "Singrauli", "Nadiad", "Secunderabad", "Naihati",
  "Yamunanagar", "Bidhan Nagar", "Pallavaram", "Bidar", "Munger", "Panchkula", "Burhanpur",
  "Raurkela Industrial Township", "Kharagpur", "Dindigul", "Gandhinagar", "Hospet", "Nangloi Jat", "Malda",
  "Ongole", "Deoghar", "Chapra", "Haldia", "Khandwa", "Nandyal", "Chittoor", "Morena", "Amroha", "Anand",
  "Bhind", "Bhalswa Jahangir Pur", "Madhyamgram", "Bhiwani", "Navi Mumbai Panvel Raigad", "Baharampur",
  "Ambala", "Morvi", "Fatehpur", "Rae Bareli", "Khora", "Bhusawal", "Orai", "Bahraich", "Vellore", "Mahesana",
  "Raiganj", "Sirsa", "Danapur", "Serampore", "Sultan Pur Majra", "Guna", "Jaunpur", "Panvel", "Shivpuri",
  "Surendranagar Dudhrej", "Unnao", "Hugli and Chinsurah", "Alappuzha", "Kottayam", "Machilipatnam", "Shimla",
  "Adoni", "Tenali", "Proddatur", "Saharsa", "Hindupur", "Sasaram", "Hajipur", "Bhimavaram", "Dehri",
  "Madanapalle", "Siwan", "Bettiah", "Guntakal", "Srikakulam", "Motihari", "Dharmavaram", "Gudivada",
  "Narasaraopet", "Bagaha", "Miryalaguda", "Tadipatri", "Kishanganj", "Karaikudi", "Suryapet", "Jamalpur",
  "Kavali", "Tadepalligudem", "Amaravati", "Buxar", "Jehanabad"
];




export const oldCities = [
  " Pan India",
  "Mumbai",
  "Delhi",
  "Bangalore",
  "Hyderabad",
  "Ahmedabad",
  "Chennai",
  "Kolkata",
  "Surat",
  "Pune",
  "Jaipur",
  "Lucknow",
  "Kanpur",
  "Nagpur",
  "Visakhapatnam",
  "Indore",
  "Thane",
  "Bhopal",
  "Patna",
  "Vadodara",
  "Ghaziabad",
  "Ludhiana",
  "Coimbatore",
  "Agra",
  "Madurai",
  "Nashik",
  "Vijayawada",
  "Faridabad",
  "Meerut",
  "Rajkot",
  "Kalyan-Dombivali",
  "Vasai-Virar",
  "Varanasi",
  "Srinagar",
  "Aurangabad",
  "Dhanbad",
  "Amritsar",
  "Navi Mumbai",
  "Allahabad",
  "Ranchi",
  "Howrah",
  "Jabalpur",
  "Gwalior",
  "Vijayawada",
  "Jodhpur",
  "Raipur",
  "Kota",
  "Guwahati",
  "Chandigarh",
  "Solapur",
  "Hubli-Dharwad",
  "Bareilly",
  "Moradabad",
  "Mysore",
  "Gurgaon",
  "Aligarh",
  "Jalandhar",
  "Tiruchirappalli",
  "Bhubaneswar",
  "Salem",
  "Warangal",
  "Guntur",
  "Bhiwandi",
  "Saharanpur",
  "Gorakhpur",
  "Bikaner",
  "Amravati",
  "Noida",
  "Jamshedpur",
  "Bhilai",
  "Cuttack",
  "Firozabad",
  "Kochi",
  "Nellore",
  "Bhavnagar",
  "Dehradun",
  "Durgapur",
  "Asansol",
  "Rourkela",
  "Nanded",
  "Kolhapur",
  "Ajmer",
  "Akola",
  "Gulbarga",
  "Jamnagar",
  "Ujjain",
  "Loni",
  "Siliguri",
  "Jhansi",
  "Ulhasnagar",
  "Nellore",
  "Jammu",
  "Sangli-Miraj & Kupwad",
  "Belgaum",
  "Mangalore",
  "Ambattur",
  "Tirunelveli",
  "Malegaon",
  "Gaya",
  "Jalgaon",
  "Udaipur",
  "Maheshtala",
];


export const SOCIAL_MEDIA = ["Instagram", "Linkedin", "Youtube", "Facebook"];
export const SOCIAL_PLATFORM = ["Instagram", "Youtube"];
export const STATUS = ["DRAFT", "PENDING", "LIVE", "REJECTED", 'UNPUBLISHED'];
export const CAMPAIGN_STATUS = ["Draft", "Pending", "Live", "Rejected", "Unpublished", "Completed"];
export const INF_TYPE = ["Micro", "Nano", "Mid Tier", "Macro"];
export const CREATOR_GENDER = ["Male", "Female", "Others"];
export const CREATOR_SOURCE = ["Admin", "Creator", "Bulk Upload"];
export const GENDER = ["Male", "Female", "Others", "Any"];
export const FOLLOWERS = ["Nano (2K-10K Followers)", "Micro (10K-25K Followers)", "Mid Tier (25K-100K Followers)", "Macro (100K-250K Followers)"];
export const FOLLOWERS_ARRAY = [{ label: "2K-10K (Nano)", value: "2K-10K", newValue: "Nano" },
{ label: "10K-25K (Micro)", value: "10K-25K", newValue: "Micro" }, { label: "25K-100K (Mid Tier)", value: "25K-100K", newValue: "Mid Tier" },
{ label: "100K-250K (Macro)", value: "100K-250K", newValue: "Macro" }, { label: "250K+ (Mega)", value: "250K", newValue: "Mega" }];
export const AGE_GROUP = ["18-25", "25-35", "35-45", "45+"];
export const NUMBER_VALIDATION = /^[0-9]+(\.[0-9]+)?$/;
export const MAX_10DIGIT = /^\d{10}$/;
export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}/; //One capital and one small and one number and one special character 

export const CREATOR_CATEGORY = ['Registered', "Verified", "Non-Verified"];

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

export const QUANTITY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

export const INFLUENCER_NICHE = "influencerNiche";
export const DELIVERABLES_QTY = "deliverablesQty";
export const DELIVERABLES_POST = "deliverablesPost";
export const KPIS = "kpis";
export const PLATEFORMS = "platforms";
export const FONT_PREFERENCES = "fontPreferences";
export const INSTAGRAM_TYPE = "instagram";
export const YOUTUBE_TYPE = "youtube";
export const INSTAGRAM_TYPE_WITH_CAPS = "Instagram";
export const YOUTUBE_TYPE_WITH_CAPS = "Youtube";
export const FAILURE = "FAILURE";
export const REMOVED = "REMOVED";



export const INFLUENCER_TYPE = "influencerType";
export const SUBSCRIPTION_FIXED_PLAN_KEY = "fixedSubscriptionPlan";
export const TRIGGER_TABLE = "triggerTable";
export const SHOPIFY_EVENTS = "shopifyEvents";
export const LANGUAGES = "languagesList";

export const INSTAGRAM = ["Instagram Image", "Instagram Reels", " Instagram Carousel"];
export const YOUTUBE = ["Yotube Video", "Youtube Shorts"];
export const CAMPAIGN_TYPE = [{ image: "", type: "paid", title: "Paid Campaign", description: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo." },
{ image: "", type: "barter", title: "Barter", description: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo." },
{ image: "", type: "performance", title: "Performance/Affiliate Campaign", description: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo." }];

export const ACHIEVE_CAMPAIGN = [{ image: "", title: "Launch Campaign" }, { image: "", title: "Awareness Campaign" },
{ image: "", title: "UGC Campaign" }, { image: "", title: "Product Reviews" },
{ image: "", title: "Testimonials" }, { image: "", title: "Long Term Association" },
{ image: "", title: "Contest/ Challenge" }
];
export const KPI_CAMPAIGN = [{ image: "11", title: "Performance Campaign", type: "performance" }, { image: "22", title: "Affiliate Campaign", type: "affiliate" }];
export const CAMPAIGN_TYPES = {
  PAID: "paid",
  BARTER: "barter",
  AFFILIATE: "affiliate",
  PERFORMANCE: "performance"
}
export const SOCIAL_PLATEFORM = {
  FB: "facebook",
  INSTAGRAM: "instagram",
  YOUTUBE: "youtube"
}

export const USER_STATUS_FILTER = ["Pending", 'Approved', 'Rejected', 'Blacklisted'];

export const USER_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  BLACKLISTED: "BLACKLISTED"
}

export const SUCCESS = "SUCCESS";
export const WEBSITE_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
export const sortedCities = citiesInIndia.sort();

// influencers.club discovery only accepts "City, India" or "India" location values
// (no India state granularity). Derive the discover dropdown options from the
// existing citiesInIndia list in that exact format. "India" stays first.
export const STATIC_LOCATIONS = [
  "India",
  ...Array.from(
    new Set(
      citiesInIndia
        .map((c) => c.trim())
        .filter((c) => c && !/^pan\s*india$/i.test(c))
        .map((c) => `${c}, India`)
    )
  ).sort(),
];
export const BID_ACCEPT = "ACCEPTED";
export const BID_REJECT = "REJECTED";
export const REBID = "REBID";
export const SUBMITTED = "SUBMITTED";
export const NEGOTIATED = "NEGOTIATED";
export const NEGOTATION = "negotation";
export const REVIEW = "REVIEW";
export const DRAFT = "DRAFT";
export const PENDING = "PENDING";
export const UNPUBLISHED = "UNPUBLISHED";
export const REJECTED = "REJECTED";
export const NEGOTATION_NEW = "NEGOTATION";
export const DELIVERED = "DELIVERED";
export const SHIPPED = "SHIPPED";
export const LIVE = "LIVE";
export const COMPANY = "company";
export const ADMIN = "admin";
export const COMPLETED = "COMPLETED"

export const getColor = (status) => {
  switch (status) {
    case 'ACCEPTED':
      return '#0077FF  !important';
    case 'REJECTED':
      return '#EF3F3F !important';
    case 'REBID':
      return '#FFC04B  !important';
    case 'SUBMITTED':
      return '#FFC04B  !important';
    case 'NEGOTIATION':
      return '#FFC04B  !important';
    case 'REVIEW':
      return "#6C7692B2  !important"
    default:
      return '#6C7692B2';
  }
}

export const PRODUCT_STATUS = ["IN PROCESS", "SHIPPED"];


export const getFixedValue = (nums) => {

  let num = parseFloat(nums);
  if (isNaN(num)) {
    return 0;
  }

  const units = ['K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  let unitIndex = -1;
  if (parseFloat(num) === undefined || parseFloat(num) === 0) {
    return 0;
  };



  let absNum = Math.abs(num);

  while (absNum >= 1000 && unitIndex < units.length - 1) {
    absNum /= 1000;
    unitIndex++;
  }

  if (unitIndex >= 0) {
    return (num / Math.pow(1000, unitIndex + 1)).toFixed(2).replace(/\.0+$/, '') + units[unitIndex];
  }

  return num !== undefined || num !== 0 || num !== "0" ? num?.toFixed(0) : 0;
};

export const getFixedValueToNonDecimal = (nums) => {
  let num = parseFloat(nums);
  if (isNaN(num) || num === 0) {
    return "0";
  }

  const units = ['K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  let unitIndex = -1;
  let absNum = Math.abs(num);

  while (absNum >= 1000 && unitIndex < units.length - 1) {
    absNum /= 1000;
    unitIndex++;
  }

  if (unitIndex >= 0) {
    return Math.floor(absNum) + units[unitIndex];
  }

  return Math.floor(num).toString();

}

export const gettwoDigitFixedValue = (price) => price?.toFixed(2);


export const getDecimal = (price) => {


  if (!isNaN(price) && price !== undefined) {
    price = parseFloat(price);
    const formattedPrice = price.toFixed(2); // Formats the number to two decimal places
    return formattedPrice
  } else {
    return 0;
  }
}

export const getDateformatUsingSeconds = (seconds) => {

  const timestamp = seconds;

  const date = new Date(timestamp);

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

export const getDaysDifference = (startDate, endDate) => {
  const startMillis = new Date(startDate).getTime();
  const endMillis = new Date(endDate).getTime();

  const differenceMillis = endMillis - startMillis;

  const daysDifference = differenceMillis / (1000 * 60 * 60 * 24);

  return Math.round(daysDifference);
}
export const MAX_FILE_SIZE = 2 * 1024 * 1024;

export const SOCKET_EVENT = {
  COMPANY_CREATED: "COMPANY_CREATED",
  CAMPAIGN_CREATED: "CAMPAIGN_CREATED",
  CAMPAIGN_APPROVED: "CAMPAIGN_APPROVED",
  BID_UPDATED: "BID_UPDATED",
  CONTENT_POST: "CONTENT_POST"
}
export const RUPEES_SYMBOL = "₹";


export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const COUNTRY_JSON = {
  "AF": "Afghanistan",
  "AX": "Åland Islands",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "American Samoa",
  "AD": "AndorrA",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua and Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgium",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BA": "Bosnia and Herzegovina",
  "BW": "Botswana",
  "BV": "Bouvet Island",
  "BR": "Brazil",
  "IO": "British Indian Ocean Territory",
  "BN": "Brunei Darussalam",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambodia",
  "CM": "Cameroon",
  "CA": "Canada",
  "CV": "Cape Verde",
  "KY": "Cayman Islands",
  "CF": "Central African Republic",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Christmas Island",
  "CC": "Cocos (Keeling) Islands",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "Congo, The Democratic Republic of the",
  "CK": "Cook Islands",
  "CR": "Costa Rica",
  "CI": "Cote D'Ivoire",
  "HR": "Croatia",
  "CU": "Cuba",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DK": "Denmark",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "EC": "Ecuador",
  "EG": "Egypt",
  "SV": "El Salvador",
  "GQ": "Equatorial Guinea",
  "ER": "Eritrea",
  "EE": "Estonia",
  "ET": "Ethiopia",
  "FK": "Falkland Islands (Malvinas)",
  "FO": "Faroe Islands",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "France",
  "GF": "French Guiana",
  "PF": "French Polynesia",
  "TF": "French Southern Territories",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germany",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GL": "Greenland",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Heard Island and Mcdonald Islands",
  "VA": "Holy See (Vatican City State)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungary",
  "IS": "Iceland",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Iran, Islamic Republic Of",
  "IQ": "Iraq",
  "IE": "Ireland",
  "IM": "Isle of Man",
  "IL": "Israel",
  "IT": "Italy",
  "JM": "Jamaica",
  "JP": "Japan",
  "JE": "Jersey",
  "JO": "Jordan",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "Korea, Democratic People'S Republic of",
  "KR": "Korea, Republic of",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Lao People'S Democratic Republic",
  "LV": "Latvia",
  "LB": "Lebanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libyan Arab Jamahiriya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "MO": "Macao",
  "MK": "Macedonia, The Former Yugoslav Republic of",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshall Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexico",
  "FM": "Micronesia, Federated States of",
  "MD": "Moldova, Republic of",
  "MC": "Monaco",
  "MN": "Mongolia",
  "MS": "Montserrat",
  "MA": "Morocco",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Netherlands",
  "AN": "Netherlands Antilles",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MP": "Northern Mariana Islands",
  "NO": "Norway",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestinian Territory, Occupied",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippines",
  "PN": "Pitcairn",
  "PL": "Poland",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Romania",
  "RU": "Russian Federation",
  "RW": "RWANDA",
  "SH": "Saint Helena",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "PM": "Saint Pierre and Miquelon",
  "VC": "Saint Vincent and the Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Sao Tome and Principe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "CS": "Serbia and Montenegro",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Solomon Islands",
  "SO": "Somalia",
  "ZA": "South Africa",
  "GS": "South Georgia and the South Sandwich Islands",
  "ES": "Spain",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SZ": "Swaziland",
  "SE": "Sweden",
  "CH": "Switzerland",
  "SY": "Syrian Arab Republic",
  "TW": "Taiwan, Province of China",
  "TJ": "Tajikistan",
  "TZ": "Tanzania, United Republic of",
  "TH": "Thailand",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Turkey",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "AE": "United Arab Emirates",
  "GB": "United Kingdom",
  "US": "United States",
  "UM": "United States Minor Outlying Islands",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Viet Nam",
  "VG": "Virgin Islands, British",
  "VI": "Virgin Islands, U.S.",
  "WF": "Wallis and Futuna",
  "EH": "Western Sahara",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
}

export const TWO_FACTOR_AUTH_VALUE = ["Select", "SMS", "Email", "Both"];

export const GROUP_TYPE = ["Community", "Notification Group"];
export const GROUP_TYPE_ENUM = {
  COMMUNITY: "Community",
  GROUP: "Notification Group"
}

export const SUBSCRIPTION_TYPE = ["Default", "Standard", "Custom"];
export const INFLUENCER_SUBSCRIPTION_TYPE = [];

export const SUBSCRIPTION_ENUM = {
  DEFUALT: "Default",
  STANDARD: "Standard",
  CUSTOM: "Custom"
}
export const SUBSCRIPTION_STATUS = {
  LIVE: "Live",
  DRAFT: "Draft",
  DISABLE: "Disabled"
}


export const SUBSCRIPTION_PRODUCT_TYPE = ["Influencer Discovery", "Campaign Management"];
export const PLAN_STATUS = ["Active", "Expired"];

export const NOTIFICATION_FERQUENCY = ["Hourly", "Daily", 'Weekly', "Monthly"];
export const NOTIFICATION_FERQUENCY_ENUM = {
  HOURLY: "Hourly",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly"
};
export const DAYS = [
  { title: 'S', value: 0 },
  { title: 'M', value: 1 },
  { title: 'T', value: 2 },
  { title: 'W', value: 3 },
  { title: 'T', value: 4 },
  { title: 'F', value: 5 },
  { title: 'S', value: 6 }
];
export const EVENT_NAME = [
  "Skateboarding Festival",
  "Wine Testing",
  "Networking Mixer Cocktail",
  "Family Fun Day",
  "Charity Run",
  "Gaming Tournament",
  "Sustainability"
];
export const RESPONSIVE_CARD_FONT_SIZE = { xs: "14px", sm: "16px", md: "16px", lg: "18px" };
export const PLATFORMS_IMGS_LIST = { "Instagram": instagramIcon, "Youtube": youTubeIcon };
export const INFLUNCER_SEARCH_FILTERS = [{ key: "influencerType", name: 'Followers' }, { key: "gender", name: 'Gender' }, { key: "location", name: 'Location' }, { key: "creatorCategory", name: 'Category' }]
export const MY_CAMPAIGNS_SEARCH_FILTERS = [{ key: "status", name: 'Staus' }, { key: "gender", name: 'Gender' }, { key: "brandId", name: 'Brand' }, { key: "type", name: 'Type' }, { key: "deliverables", name: 'Posted On' }]
export function hexToRgba(hex, opacity) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
export const CAMPAIGN_TYPES_WITH_DETAILS = [
  {
    icon: paidCampaignIcon,
    type: "paid",
    heading: "Paid - Fixed per content",
    subheading: "A payment negotiated individually with each of your collaborators"
  },
  {
    icon: giftingCampaignIcon,
    type: "barter",
    heading: "Product Gifting",
    subheading: "A payment negotiated individually with each of your collaborators"
  },
  {
    icon: salesCampaignIcon,
    type: "performance",
    heading: "Sales Commission",
    subheading: "For every purchase generated, your collaborator will receive a commission"
  }
]
export const CAMPAIGNS_SUB_TYPES = [{ icon: rocketIcon, name: 'Launch Campaign' }, { icon: bulbIcon, name: "Awareness Campaign" },
{ icon: boxIcon, name: "UGC Campaign" }, { icon: starIcon, name: "Product Reviews" }, { icon: testimonialIcon, name: "Testimonials" },
{ icon: longTermIcon, name: "Long Term Association" }, { icon: contestIcon, name: "Contest/ Challenge" }
]
export const PERFORMANCE_CAMPAIGNS_SUB_TYPES = [{ icon: performanceCampaignIcon, name: "Performance Campaign", type: "performance" }, { icon: affiliateCampaignIcon, name: "Affiliate Campaign", type: "affiliate" }];
export const CAMPAIGN_BANNER_IMAGE_ALLOWED_DIMESHION = [
  { width: 1920, height: 1080 },
  { width: 1280, height: 720 },
  { width: 1024, height: 576 },
  { width: 711, height: 400 },
];
export const CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES = ['image/jpeg', 'image/png'];
export const FORM_INPUTFIELD_STYLES = {
  '& .MuiOutlinedInput-root': {
    position: 'relative',
    zIndex: 1,
    backgroundColor: '#fff',
    borderRadius: '8px',
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #CCCBCB',
      background: 'rgba(238, 238, 238, 0.3)',
      transition: 'background 0.4s ease',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -2,
      left: -2,
      right: -2,
      bottom: -2,
      borderRadius: 'inherit',
      padding: '1px',
      background: 'linear-gradient(90deg,rgba(255, 204, 112, 0.4) 0%, rgba(200, 80, 192, 0.4) 50%, rgba(65, 88, 208, 0.4) 100%)',
      zIndex: -1,
      opacity: 0,
      transition: 'opacity 0.4s ease',
    },
    '&.Mui-focused::before': {
      opacity: 1,
    },
    "& .MuiOutlinedInput-input": {
      background: '#fff', borderRadius: '8px', "&:hover": {
        border: 0,
      },
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #CCCBCB',
      background: 'transparent',
      transition: 'border 0.4s ease, background 0.4s ease',
    },
  },
}
export const FORM_SELECTFIELD_STYLES = {
  borderRadius: "8px",
  background: "white",
  position: "relative",
  width: '100%',
  borderColor: "transparent",
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
      boxShadow: 'none',

      border: '1px solid #CCCBCB',
      background: 'transparent',
      transition: 'border 0.4s ease, background 0.4s ease',
    },
    '&:focus': {
      outline: 'none',
    },
    "&:hover  .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #CCCBCB',
      background: 'rgba(238, 238, 238, 0.3)',
      transition: 'background 0.4s ease',
    },
  },
  // for normal select
  "&:hover  .MuiOutlinedInput-notchedOutline": {
    border: '1px solid #CCCBCB',
    background: 'rgba(238, 238, 238, 0.3)',
    transition: 'background 0.4s ease',
  },
  "& .MuiSelect-select": {
    padding: '0 0px 0 13px !important',
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: '1px solid #CCCBCB',
    background: 'transparent',
    transition: 'border 0.4s ease, background 0.4s ease',
  },
  "::before": {
    content: '""',
    position: "absolute",
    top: -2,
    left: -2,
    right: -2,
    bottom: -2,
    padding: "2px",
    borderRadius: "10px",
    background: 'linear-gradient(90deg,rgba(255, 204, 112, 0.4) 0%, rgba(200, 80, 192, 0.4) 50%, rgba(65, 88, 208, 0.4) 100%)',
    "-webkit-mask":
      "linear-gradient(white, white) content-box, linear-gradient(white, white)",
    "-webkit-mask-composite": "destination-out",
    maskComposite: "exclude",
    pointerEvents: 'none',
    opacity: 0,
    outline: 0,
    transition: 'opacity 0.4s ease',
  },

  "&.Mui-focused, &:focus-within,&:focus-visible": {
    "::before": {
      opacity: 1,
      transition: 'opacity 0.4s ease',
    },
  },
  padding: '0px',
  outline: 0,
}
export const CustomSearchInput = styled(SearchInput)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "50px !important",
  },
  "& input": {
    padding: '0px !important', paddingLeft: '0px !important'
  }
});
export const START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT = <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
  sx={{
    maxHeight: 'none',
    height: '38px',
    minWidth: '38px',
    marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
  }}
>
  <img src={searchIcon} height={20} width={20} alt="" srcset="" />
</InputAdornment>
export const TABLE_HEADER_ROW_MUI_STYLES = { background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }
export const TABLE_BODY_ROW_MUI_STYLES = { "&:hover": { backgroundColor: '#F0F7FF !important', "& td": { backgroundColor: "inherit !important" }, }, height: '60px' }
export const CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST = (props) => {
  return (
    <Paper
      {...props}
      elevation={3}
      sx={{
        borderRadius: '10px',
        marginTop: 1,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: '300px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    />
  );
}
export const CAMPAIGNS_STATUS_CARD = [{ key: 'totalCount', name: 'Total Campaign', icon: totalCampaignIcon },
{ key: 'liveCount', name: 'Live Campaign', icon: liveCampaignIcon },
{ key: 'draftCount', name: 'Draft Campaign', icon: draftCampaignIcon },
{ key: 'completedCount', name: 'Completed Campaign', icon: completeCampaignIcon },
{ key: 'unpublishedCount', name: 'Unpublished Campaign', icon: uncompleteCampaignIcon },
]
export const trunCateString = (str, limit) => {
  if (typeof str !== 'string' || typeof limit !== 'number') return "provide valid string and limit";
  return str.length > limit ? str.substring(0, limit) + '...' : str;
}
export const InfluencerListAi = [{
  "id": 139828,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/327014781_750791139868926_3222630747372094348_n.jpg",
  "name": "Sunny mudgal",
  "instagram": "travelingg_dude",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"\", \"option\": \"Travel & Adventure\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "117975",
  "location": " ",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 9747.7668,
      "avg_views": 0,
      "total_posts": 193,
      "avg_comments": 61.2487,
      "engagement_rate": 8.3144865,
      "estimated_reach": 161467.1295
    },
    "reels": {
      "avg_likes": 11040.3706,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 68.6588,
      "engagement_rate": 9.4164267,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 142199,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/470365970_1653858368867861_2694051307771571667_n.jpg",
  "name": "Tanu Bana",
  "instagram": "_traveltweet_",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"\", \"option\": \"Travel & Adventure\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"/app/signup/Fashion.png\", \"option\": \"Fashion & Style\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"/app/signup/Beauty.png\", \"option\": \"Beauty & Personal Care\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "130491",
  "location": "New Delhi - 110046",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 154.8295,
      "avg_views": 0,
      "total_posts": 657,
      "avg_comments": 12.0791,
      "engagement_rate": 0.1279081,
      "estimated_reach": 914.519
    },
    "reels": {
      "avg_likes": 156.8039,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 12.5406,
      "engagement_rate": 0.1297748,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 1,
        "avg_likes": 61,
        "avg_comments": 17,
        "engagement_rate": 0.0597742,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 144046,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/2025/7/144046/2/file.jpg",
  "name": "Bunny Sadhnani ",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Fashion.png\", \"option\": \"Fashion & Style\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"\", \"option\": \"Travel & Local Exploration\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"\", \"option\": \"Travel & Adventure\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "183084",
  "location": "Jaipur ",
  "instagram": "globetrotterbunny",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 337.4165,
      "avg_views": 0,
      "total_posts": 665,
      "avg_comments": 5.4782,
      "engagement_rate": 0.1872881,
      "estimated_reach": 806.4677
    },
    "reels": {
      "avg_likes": 519.6681,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 7.7059,
      "engagement_rate": 0.2880502,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 137302,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/473627481_1682606216001308_6307914395171164571_n.jpg",
  "name": "Srishti Gosavi",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Education&Jobs.png\", \"option\": \"Education & Learning\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"/app/signup/Finance.png\", \"option\": \"Finance & Investing\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"\", \"option\": \"Travel & Adventure\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "367316",
  "location": "Mumbai",
  "instagram": "nerd_in_you",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 3325.8609,
      "avg_views": 0,
      "total_posts": 762,
      "avg_comments": 60.0971,
      "engagement_rate": 0.9218106,
      "estimated_reach": 125002.9869
    },
    "reels": {
      "avg_likes": 3935.7106,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 71.0884,
      "engagement_rate": 1.0908316,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 134626,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/470326341_2090901637994442_5114881034061074326_n.jpg",
  "name": "Shweta Mishrra",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Auto.png\", \"option\": \"Automotive & Vehicles\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"/app/signup/Food&Cooking.png\", \"option\": \"Food & Cooking\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"\", \"option\": \"Parenting & Family\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "222631",
  "instagram": "shwetasawarnik",
  "location": "Delhi ",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 4495.1399,
      "avg_views": 0,
      "total_posts": 3530,
      "avg_comments": 123.4297,
      "engagement_rate": 2.0745402,
      "estimated_reach": 9436.7606
    },
    "reels": {
      "avg_likes": 7953.0165,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 156.9424,
      "engagement_rate": 3.6427806,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 2,
        "avg_likes": 1389,
        "avg_comments": 265,
        "engagement_rate": 0.7429333,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 128290,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/455291808_481577811392204_1428512555796566296_n.jpg",
  "name": "Vaishali Garg",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Food&Cooking.png\", \"option\": \"Food & Cooking\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "107278",
  "location": "New delhi",
  "influencerType": null,
  "instagram": "mynutritionpalette",
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 5730.157,
      "avg_views": 1400.4437,
      "total_posts": 293,
      "avg_comments": 50.7304,
      "engagement_rate": 5.3886979,
      "estimated_reach": 240371.7713
    },
    "reels": {
      "avg_likes": 5904.0458,
      "avg_views": 1444.8239,
      "view_rate": 1.3468035,
      "avg_comments": 52.0423,
      "engagement_rate": 5.5520126,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 131007,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/475199186_545438615197455_303594722108108966_n.jpg",
  "name": "bhagyashree",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Gaming&Sports.png\", \"option\": \"Gaming & Esports\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "126166",
  "location": "Bhinmal",
  "instagram": "bhagyashree_ff",
  "influencerType": null,
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 3458.7109,
      "avg_views": 0,
      "total_posts": 4711,
      "avg_comments": 22.4738,
      "engagement_rate": 2.7592098,
      "estimated_reach": 21627.5578
    },
    "reels": {
      "avg_likes": 3471.1178,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 22.5093,
      "engagement_rate": 2.7690717,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
},
{
  "id": 142011,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/497915976_18044034800441976_5771198329184969496_n.jpg",
  "name": "Aakanksha Tambat ",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"\", \"option\": \"Relationships & Dating\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"/app/signup/Diy&Hobbies.png\", \"option\": \"Hobbies & Leisure Activities\", \"bgcolor\": \"#EEEEEE\"}, {\"image\": \"\", \"option\": \"Entertainment & Pop Culture\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "455239",
  "location": " ",
  "influencerType": null,
  "instagram": "aakanksha_mjdi",
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 32041.5414,
      "avg_views": 0,
      "total_posts": 713,
      "avg_comments": 99.4165,
      "engagement_rate": 7.0602382,
      "estimated_reach": 214485.6171
    },
    "reels": {
      "avg_likes": 33662.2544,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 102.4038,
      "engagement_rate": 7.416908,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
}, {
  "id": 137449,
  "status": "APPROVED",
  "creatorCategory": "Registered",
  "picture": "https://df7towsrrwicd.cloudfront.net/influencer/profile/2025/6/137449/4/file.jpg",
  "name": "Tejas Manish Shetye",
  "platformUrls": "[]",
  "profileNiche": "[{\"image\": \"/app/signup/Comedy.png\", \"option\": \"Humor & Comedy\", \"bgcolor\": \"#EEEEEE\"}]",
  "followers": "257981",
  "location": "Mumbai",
  "influencerType": null,
  "instagram": "teekhabanao",
  "platformType": "instagram",
  "Engagement": {
    "posts": {
      "avg_likes": 94432.0056,
      "avg_views": 0,
      "total_posts": 531,
      "avg_comments": 530.8173,
      "engagement_rate": 36.8100065,
      "estimated_reach": 851481.1959
    },
    "reels": {
      "avg_likes": 105493.0085,
      "avg_views": 0,
      "view_rate": 0,
      "avg_comments": 592.0191,
      "engagement_rate": 41.121256,
      "estimated_reach": 0
    },
    "paid_partnerships": {
      "posts": {
        "total": 0,
        "avg_likes": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      },
      "reels": {
        "total": 0,
        "avg_likes": 0,
        "avg_views": 0,
        "view_rate": 0,
        "avg_comments": 0,
        "engagement_rate": 0,
        "estimated_reach": 0
      }
    }
  }
},]
export const TOOLTIP_STYLES = {
  tooltip: {
    sx: {
      backgroundColor: "white !important",
      color: "black",
      fontSize: "12px",
      fontWeight: "500",
      padding: "5px 10px !important",
      borderRadius: "6px", minWidth: '100px',
      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", border: '1px solid #F0F0F0 !important', textTransForm: 'capitalize'
    },
  },
  arrow: {
    sx: {
      color: "white !important",
      "&::before": {
        backgroundColor: "white", border: '1px solid #F0F0F0 !important',
      },
    },
  },
};

export const hideScrollbarCss = {
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  }
}

export const mainGradient = 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)';
export const gradientText = {
  background: "linear-gradient(90deg, #FFCC70 0%, #C850C0 50%, #4158D0 100%)",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
}